// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes mapBlinker {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  } 

  .blinkAsset{
    animation: mapBlinker 1s infinite alternate;
  }`, "",{"version":3,"sources":["webpack://./src/components/ArchilogicMap/Archilogic.css"],"names":[],"mappings":"AAAA;IACI,KAAK,UAAU,EAAE;IACjB,MAAM,UAAU,EAAE;IAClB,OAAO,UAAU,EAAE;EACrB;;EAEA;IACE,2CAA2C;EAC7C","sourcesContent":["@keyframes mapBlinker {\n    0% { opacity: 1; }\n    50% { opacity: 0; }\n    100% { opacity: 1; }\n  } \n\n  .blinkAsset{\n    animation: mapBlinker 1s infinite alternate;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
